import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  standalone: false,
  templateUrl: './plan-comment-topic-modal.component.html',
  styleUrls: ["../../../../styles.scss"],
})

export class PlanCommentTopicModalComponent implements OnInit {
  @Input() availableTopics: string[] = [];
  @Input() serviceTreeId: string;
  @Input() region: string;
  @Input() version: number;
  @Input() blueprint: string;
  @Input() currentUser: string;
  @Input() selectedCommentTopic: string; // Renamed to match other components

  commentText: string = '';

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    // Set default topic if not already selected and options exist
    if (!this.selectedCommentTopic && this.availableTopics && this.availableTopics.length > 0) {
      this.selectedCommentTopic = this.availableTopics[0];
    }
  }

  /**
   * Validates if the form is valid for submission
   * @returns boolean indicating if the form is valid
   */
  isValid(): boolean {
    return this.selectedCommentTopic && this.commentText && this.commentText.trim().length > 0;
  }

  /**
   * Saves the comment topic and text and closes the modal
   */
  save() {
    this.activeModal.close({
      topic: this.selectedCommentTopic,
      comment: this.commentText,
    });
  }

  /**
   * Cancels the operation and closes the modal
   */
  cancel() {
    this.activeModal.dismiss('cancel');
  }
}
